.jp{pointer-events:auto;}